import React from 'react';

const Privatpolitik = () => {
  return (
    <div className="pt-20 pb-24 bg-gray-50">
      <div className="section-container max-w-4xl mx-auto py-12 px-4">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
          <div className="space-y-4">
            <h1 className="text-3xl md:text-4xl font-bold text-primary">
              COOKIE- OG PRIVATLIVSPOLITIK
            </h1>
            <h2 className="text-2xl font-semibold text-gray-800">
              RV MURERENTREPRISE ApS
            </h2>
          </div>

          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Introduktion</h3>
              <p className="text-gray-700 leading-relaxed">
                Når du besøger vores website bliver der indsamlet oplysninger om dig, som bliver brugt til at tilpasse og forbedre vores indhold og til at skabe mere værdi hos de annoncer, der vises på siden. Hvis du ikke ønsker, at der bliver indsamlet oplysninger om dig, bør du slette dine cookies og undlade videre brug af hjemmesiden. I de nedenstående afsnit har vi uddybet, hvad det er for informationer, der indsamles, deres formål og hvilke tredjeparter, der har adgang til dem.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Cookies</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Hjemmesiden anvender "cookies", som er en tekstfil, der gemmes på din computer, mobil el. tilsvarende med formålet at genkende den, huske indstillinger, udføre statistik og målrette annoncer. Cookies kan dog ikke indeholde skadelig kode som fx. virus.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Det er muligt for dig at slette eller blokere for cookies. Det kan du gøre ved at følge denne vejledning:{' '}
                <a 
                  href="http://minecookies.org/cookiehandtering"
                  className="text-primary hover:text-secondary underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  http://minecookies.org/cookiehandtering
                </a>
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">PERSONOPLYSNINGER</h3>
              
              <div className="space-y-4">
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">Generelt</h4>
                  <p className="text-gray-700 leading-relaxed">
                    Personoplysninger er alle former for informationer, som i et eller andet omfang kan henføres til dig. Når du benytter vores website, så indsamler og behandler vi en række af sådanne informationer. Det sker f.eks. ved helt almindelige interaktioner på hjemmesiden som fx at du tilmelder dig vores nyhedsbrev, deltager i en konkurrence/undersøgelse, registrerer dig som ny bruger/abonnent eller ved øvrig brug af services eller køb via vores hjemmeside.
                  </p>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">Sikkerhed</h4>
                  <p className="text-gray-700 leading-relaxed">
                    Vi behandler dine personoplysninger sikkert og fortroligt i overensstemmelse med gældende lovgivning, herunder persondataforordningen og databeskyttelsesloven. Dine oplysninger vil alene blive anvendt til det formål, de er indsamlet til og vil blive slettet, når dette formål er opfyldt eller ikke længere er relevant.
                  </p>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">Formål</h4>
                  <p className="text-gray-700 leading-relaxed">
                    Oplysningerne bruges til at identificere dig som bruger og vise dig de annoncer, som vil have mest relevans for dig, at registrere dine køb og betalinger, samt at kunne levere dig de services, du har efterspurgt, som fx at modtage nyhedsbreve. Derudover anvender vi oplysningerne til at optimere og forbedre vores services og indhold.
                  </p>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">Indsigt og klager</h4>
                  <p className="text-gray-700 leading-relaxed">
                    Du har ret til at få oplyst, hvilke personoplysninger, vi behandler om dig i et almindeligt format (dataportabilitet). Du kan desuden til enhver tid gøre indsigelse mod, at oplysningerne anvendes. Du kan også tilbagekalde dit samtykke til, at der bliver behandlet oplysninger om dig. Hvis de oplysninger, der behandles om dig, er forkerte har du ret til, at de bliver rettet eller slettet.
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t pt-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Udgiver</h3>
              <div className="text-gray-700 space-y-1">
                <p className="font-semibold">Firma: Murermester Voss</p>
                <p>Adresse: Søgårdsvej 7, 4550 Asnæs</p>
                <p>CVR: 498786732312</p>
                <p>Email: murermester_voss@gmail.com</p>
                <p>Telefon: +45 2858 8607</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privatpolitik;
